import { Route } from "react-router-dom";
import { _adr } from "../address";
import { ProtectedRouteLogin } from "../tools/protectedRoute";
import Login from "../components/security/login/login";
import ForgetPassword from "../components/security/forgetpassword/forgetpass";
import TwoStepConfirm from "../components/security/twoStepConfirm";
import ChangePassword from "../components/security/changepassword/changePassword";

export const loginRoutes = [
	<Route key="root" path={"/"} element={<ProtectedRouteLogin path={"/"} element={Login} />} />,
	<Route key="app-root" path={_adr.Root} element={<ProtectedRouteLogin path={"/"} element={Login} />} />,
	<Route key="login" path={_adr.Root + _adr.Login.Index} element={<ProtectedRouteLogin element={Login} />} />,
	<Route key="forget-password" path={_adr.Root + _adr.Login.ForgetPassword} element={<ProtectedRouteLogin element={ForgetPassword} />} />,
	<Route key="otp-confirm" path={_adr.Root + _adr.Login.OtpConfirm} element={<ProtectedRouteLogin element={TwoStepConfirm} />} />,
	<Route key="reset-password" path={_adr.Root + _adr.Login.ResetPassword} element={<ProtectedRouteLogin element={ChangePassword} />} />,
];
